import "./introduction.css"
function Introduction(para){
  const textData = para["textData"];
  // useEffect(()=>{
  //   const observer = new IntersectionObserver(entries => {
  //     entries.forEach(entry => {
  //       if (entry.isIntersecting) {
  //         entry.target.classList.add('animateDescriptionText');
  //       return;
  //       }
  //     });
  //   });
  //   observer.observe(document.querySelector('.descriptionText'));
  // });
  
  return(
    <div id = "introduction">
      <div id = 'bgIMG'>
        <img src = {process.env.PUBLIC_URL+"/background/DSC_0460.jpg"} alt = "background" width={"100%"} height={"100%"}/>
      </div>
      <div className='descriptionText'>
      <div id='descriptionText_1'>
        {textData["intro_header"]}
      </div>
      <br />
      <div id='descriptionText_2'>
        &nbsp;&nbsp;{textData["intro_line1"]}
      </div>
      <br />
      <div id='descriptionText_3'>
        &nbsp;&nbsp;{textData["intro_line2"]}
      </div>
      <br />
      <div id='descriptionText_4'>
        &nbsp;&nbsp;{textData["intro_line3"]}
      </div>
      <br />
      <div id='descriptionText_5'>
        &nbsp;&nbsp;{textData["intro_line4"]}
      </div>
      
      </div>
    </div>
  )
}
export default Introduction;